import React from "react";
import { stats } from "../mock";

export default function Stats() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((s) => (
            <div key={s.id} className="relative bg-gray-50 border border-gray-100 rounded-2xl p-8 text-center card-hover">
              <div className="font-display text-5xl lg:text-6xl font-bold text-brand">{s.value}</div>
              <div className="mt-2 text-sm font-semibold text-gray-700 uppercase tracking-wider">{s.label}</div>
              <div className="absolute inset-x-8 bottom-4 h-0.5 bg-brand/10" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
